import { Formik, FormikConfig, FormikProps } from 'formik';
import Rule from './Rule';
import { ReactNode } from 'react';
import { UnConfigStore } from 'views/BootGuide/views/AiModel/share';

export interface KnowledgeListFormProps<T extends Knowledge.KnowledgeType>
  extends FormikConfig<any> {
  knowledgeType: T;
  stores: UnConfigStore[];
  storeMap: Partial<Record<number, UnConfigStore>>;
  children: (form: ReactNode, props: FormikProps<Knowledge.KnowledgeItem[]>) => ReactNode;
  onEdit: (knowledgeValue: Knowledge.KnowledgeItem) => void;
}

function KnowledgeListForm<T extends Knowledge.KnowledgeType>(props: KnowledgeListFormProps<T>) {
  const { initialValues, knowledgeType, children, onEdit, stores, storeMap, ...otherProps } = props;

  return (
    <>
      <Formik
        {...otherProps}
        initialValues={{ kc: initialValues }}
        validateOnChange={false}
        enableReinitialize
      >
        {(props) => {
          const form = props.values.kc.map((value, index) => {
            return (
              <Rule
                key={value.id}
                index={index}
                knowledgeType={knowledgeType}
                knowledgeValue={value}
                stores={stores}
                storeMap={storeMap}
                onEdit={onEdit}
              />
            );
          });

          return children(form, props);
        }}
      </Formik>
    </>
  );
}

export default KnowledgeListForm;
